import 'css-chunksrc/client/pages/projectPage/discussionsPage/discussions/discussion/styles.scss';export default {
  "header": "_header_j8snb_1",
  "iconBox": "_iconBox_j8snb_12",
  "icon": "_icon_j8snb_12",
  "subjectIcon": "_subjectIcon_j8snb_29",
  "name": "_name_j8snb_35",
  "row": "_row_j8snb_42",
  "commentCount": "_commentCount_j8snb_56",
  "contextualMenu": "_contextualMenu_j8snb_64",
  "trashIcon": "_trashIcon_j8snb_71",
  "comments": "_comments_j8snb_79",
  "closed": "_closed_j8snb_89",
  "replyInput": "_replyInput_j8snb_97"
};